// extracted by mini-css-extract-plugin
export var chevronIcon = "_40-2";
export var teamName = "_40-1";
export var teamSwitcherButton = "_40-0";